import { render } from "./registrations.vue?vue&type=template&id=21a7a5ef&scoped=true"
import script from "./registrations.vue?vue&type=script&lang=js"
export * from "./registrations.vue?vue&type=script&lang=js"

import "./registrations.vue?vue&type=style&index=0&id=21a7a5ef&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-21a7a5ef"

export default script